module.exports = __webpack_public_path__ + "static/media/403405-PCSCAQ-741.f6a6dd70.jpg";